export default "__VITE_ASSET__DpxgIlIe__"